import {
  EXAM_TYPES,
  type ExamType,
} from "$global-providers/rxdb-provider/collections/epocus-exam-worksheets";
import { useMemo } from "react";
import { EXAM_ICONS, EXAM_LABELS } from "./epocus-exam-constants";
import type { HealthIconComponent } from "./epocus-icons";
import { selectActiveProgram, useMyPrograms } from "./use-active-program";

export const selectEnabledExamTypes = (
  enabled: readonly ExamType[] | undefined,
): readonly ExamType[] => {
  if (!enabled || enabled.length === 0) return EXAM_TYPES;

  const enabledSet = new Set(enabled);
  const narrowed = EXAM_TYPES.filter((examType) => enabledSet.has(examType));

  return narrowed.length === 0 ? EXAM_TYPES : narrowed;
};

export const useEnabledExamTypes = (): readonly ExamType[] => {
  const { programs } = useMyPrograms();

  return useMemo(
    () =>
      selectEnabledExamTypes(selectActiveProgram(programs)?.enabledExamTypes),
    [programs],
  );
};

export const useEnabledExamTypeOptions = (): readonly {
  type: ExamType;
  label: string;
  Icon: HealthIconComponent;
}[] => {
  const examTypes = useEnabledExamTypes();

  return useMemo(
    () =>
      examTypes.map((type) => ({
        type,
        label: EXAM_LABELS[type],
        Icon: EXAM_ICONS[type],
      })),
    [examTypes],
  );
};
